var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "commentSubmitRef", staticClass: "comment-submit" }, [
    _c("div", { staticClass: "box" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.comment,
            expression: "comment",
          },
        ],
        ref: "commentEditor",
        class: !_vm.isLogin && "textarea-unlogin",
        attrs: { placeholder: "来说两句吧......", rows: _vm.maxRow },
        domProps: { value: _vm.comment },
        on: {
          focus: function ($event) {
            _vm.handleFocus(3)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.comment = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      !_vm.isLogin && !_vm.isFocus
        ? _c(
            "div",
            { staticClass: "unlogin-unfocus", on: { click: _vm.login } },
            [_vm._v(_vm._s(_vm.unLoginSubmitText))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.isLogin
      ? _c("div", { staticClass: "login-btns" }, [
          _vm.showUser
            ? _c("a", { attrs: { href: "https://passport.sohu.com/" } }, [
                _c("img", {
                  staticClass: "avatar",
                  attrs: { src: _vm.userInfo.avatar },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "username" }, [
                  _vm._v(_vm._s(_vm.userInfo.nickname)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "emoji",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.handleShowEmoji($event)
                },
              },
            },
            [
              _vm.showEmoji
                ? _c("Emoji", { on: { chooseEmoji: _vm.chooseEmoji } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pics", on: { click: _vm.chooseImg } },
            [
              _vm.showUploadImg
                ? _c("UploadImg", {
                    attrs: { uploadedImg: _vm.unPbulishImgBase64 },
                    on: { closeUploadImg: _vm.closeUploadImg },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            ref: "imgInputRef",
            staticClass: "img-input",
            attrs: {
              name: "file",
              type: "file",
              accept: "image/jpg,image/jpeg,image/webp,image/png,image/gif",
            },
            on: { change: _vm.handleFileChange },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "icon-at",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.handleClickAt($event)
                },
              },
            },
            [
              _vm.showAtList
                ? _c("AtUserList", {
                    ref: "searchUser",
                    attrs: {
                      articleId: _vm.articleId,
                      accountId: _vm.accountId,
                    },
                    on: {
                      selectUser: _vm.handleAtUser,
                      hide: function ($event) {
                        _vm.showAtList = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "submit", on: { click: _vm.handlePublish } },
            [_vm._v(_vm._s(_vm.loginSubmitText))]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showLoginBtn
      ? _c("div", { staticClass: "un-login-btns" }, [
          _c("div", { staticClass: "left" }, [
            _c("span", [_vm._v("快速登录：")]),
            _vm._v(" "),
            _c("a", {
              staticClass: "instanse",
              attrs: { href: "javascript:;" },
              on: { click: _vm.login },
            }),
            _vm._v(" "),
            _c("a", {
              staticClass: "wechat",
              attrs: { href: "javascript:;" },
              on: {
                click: function ($event) {
                  _vm.thirdLogin("wx")
                },
              },
            }),
            _vm._v(" "),
            _c("a", {
              staticClass: "qq",
              attrs: { href: "javascript:;" },
              on: {
                click: function ($event) {
                  _vm.thirdLogin("qq")
                },
              },
            }),
            _vm._v(" "),
            _c("a", {
              staticClass: "wb",
              attrs: { href: "javascript:;" },
              on: {
                click: function ($event) {
                  _vm.thirdLogin("wb")
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "submit", on: { click: _vm.login } }, [
            _vm._v(_vm._s(_vm.unLoginSubmitText)),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }